export { isNetworkClass as durableNetworkFallback } from "@utils/durableCache/createDurableCache";
